<div [formGroup]="parentGroup" appPreventDoubleClick (throttledClick)="$event.stopPropagation(); openSelectGoalPlanDialog()">
    <mat-form-field appearance="fill" [ngClass]="{'invisible':formElement.hidden === 'true'}">
        <mat-label>
            {{ formElement.text }}
            <span class="asterisk" *ngIf="formElement.requiredField">*</span>
            <span class="sr-only" *ngIf="readOnly">{{ 'Read-only' | translate: {Default: 'Read-only'} }}</span>
        </mat-label>

        <span matSuffix 
          *ngIf="!readOnly && !parentGroup.controls[this.formElement.formControl].disabled && goalPlanOptions.length > 0"
          style="margin-right: 8px;">
          <mat-icon 
            setColor 
            [setColorRules]="[
                {
                    color: 'primaryColour',
                    events: ['hover']
                }
            ]"
            class="material-icons-outlined clickable-icon" 
            appPreventDoubleClick (throttledClick)="$event.stopPropagation(); clearSelectedPosition()">close</mat-icon>
        </span>

        <mat-select disableOptionCentering #goalPlanSelect [formControlName]="formElement.formControl" appPreventDoubleClick (throttledClick)="$event.stopPropagation(); openSelectGoalPlanDialog()"
              [attr.aria-disabled]="readOnly"
              [attr.aria-readonly]="readOnly">
              <mat-option></mat-option>

              <ng-container>
                <mat-option *ngFor="let option of goalPlanOptions" [value]="option.id">{{option.name}}</mat-option>
              </ng-container>
        </mat-select>
        <mat-icon *ngIf="readOnly" matSuffix class="material-icons-outlined disabled-field-icon" aria-hidden="false" [attr.aria-label]="'Read-only' | translate: {Default: 'Read-only'}">lock</mat-icon>
    </mat-form-field>
</div>
